document.addEventListener("DOMContentLoaded", () => {
  const siteMain = document.querySelector('.site-main');
  if(siteMain){
    setMainPaddingBottom();
    window.addEventListener("resize", setMainPaddingBottom);
    window.addEventListener("orientationchange", setMainPaddingBottom);
  }
});
function setMainPaddingBottom() {
  let footer = document.querySelector(".site-footer");
  let main = document.querySelector(".site-main");
  footerHeight = footer.offsetHeight;

  main.style.paddingBottom = footerHeight + "px";
  main.style.marginBottom = "-" + footerHeight + "px";
}
document.addEventListener("DOMContentLoaded", function () {
  const widgetTitles = document.querySelectorAll(
    ".footer-widget .widget-title"
  );
  const menu = document.querySelectorAll(".footer-widget .menu");
  if (widgetTitles && menu) {
    widgetTitles.forEach((title, index) => {
      title.addEventListener("click", function (event) {
        this.classList.toggle("active");
        if (menu[index]) {
          menu[index].classList.toggle("active");
        }
      });
    });
  }

});